<template>
  <div class="HotelIcon" :class="`${iconStyle} ${mode} ${iconForm}`" :style="{width:containerSize+'px', height:containerSize+'px'}">
    <img class="icon" :src="showIcon" :width="iconSize" :height="iconSize"/>

  </div>
</template>

<script>


export default {
  name: 'HotelIcon',
  props:['icon','size','stl','cSize','mode','form'],
  data: () => ({
    showIcon:undefined,
    iconSize:13,
    containerSize:24,
    textSize:12,
    iconStyle:'light',
    iconMode:'fill',
    iconForm:'round'

  }),
  mounted() {
    this.$nextTick(async ()=>{
      this.showIcon = require(`@/assets/icons/${this.icon}.png`)
      if(this.size){this.iconSize=this.size}
      if(this.form){this.iconForm=this.form}
      if(this.cSize){this.containerSize=this.cSize}
      if(this.mode){this.iconMode=this.mode}
      if(this.iconMode==='plain'){this.containerSize=this.iconSize}
      if(this.stl){this.iconStyle=this.stl}
      if(this.$screen.device==='mobile'){
        this.iconSize =11
        this.containerSize =18
      }
    })
  }
}
</script>


<style scoped>

  .HotelIcon{
    display: grid;
    height: 24px;
    width: 24px;
    overflow: hidden;
    align-content: center;
    justify-content: center;
    background-color: #a7a7a7;
  }

  .HotelIcon.plain{background:none; height: initial; width: initial}
  .HotelIcon.box{border-radius: 0px}
  .HotelIcon.round{border-radius: 50% !important}
  .HotelIcon.light>.icon{filter: invert()}

</style>